/**
 * Transforms a string into kebab case
 * @param {string} a string to be converted to kebab case
 */
export const kebabCase = str =>
  str
    ? str
        .toString()
        .toLowerCase()
        .replace(/[^a-zA-Z0-9]+/g, '-')
    : null;

// exports
export const StringUtils = {
  kebabCase: kebabCase
};
export default StringUtils;
